var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { g } from "analytics";
import { BACKEND_API } from "api/api";
import { loginProviderDisplayName, loginProviderIcon } from "api/auth/login_button";
import { reauthFromCurrentLogin } from "api/auth/reauth";
import { releasedItemsCount } from "apparatus/spec_list";
import { CommonModal } from "components/common_modal";
import { format } from "date-fns";
import { t } from "i18next";
import { getDateFnsLocale } from "i18n_utils";
import { ManageGroup } from "layout/modals/account/group";
import { StaySignedInCheckbox } from "layout/modals/login_modal";
import { clog } from "log";
import * as React from "react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import store from "store/store";
import { Bcn } from "support/beacon";
import { TierContext } from "tiers/context";
import { BOOST_TOTAL_DIAGRAMS } from "tiers/promo";
import { BoostFeatureList, ExportHighQuality, Item } from "tiers/promo_plus";
import { Toast } from "toast";
import { Nl } from "view/tooltips";
import { callApi } from "../../api/api";
import { clearToken, retrieveToken, storeToken } from "../../api/auth/storage";
import { logOut } from "../../store/actions";
import { Badge, SchoolBadge } from "../../tiers/badge";
import { opensWindow } from "../../utils";
export class MyAccountModal extends React.Component {
    constructor(props) {
        super(props);
        this.cancelSubscription = () => {
            callApi("plans/cancel", "POST", this.props.auth, undefined, {
                success: () => {
                    toastr.success(t("my_account.cancel_success"));
                    this.refreshAccountDetails();
                },
                generic: () => {
                    Toast.error(t("my_account.error_contact"), t("my_account.cancel_error"));
                }
            });
        };
        this.resumeSubscription = () => {
            g("OpenStripePortal");
            callApi("plans/resume", "POST", this.props.auth, undefined, {
                success: () => {
                    toastr.success(t("my_account.resume_success"));
                    this.refreshAccountDetails();
                },
                generic: () => {
                    Toast.error(t("my_account.error_contact"), t("my_account.resume_error"));
                }
            });
        };
        this.openStripeCustomerPortal = () => {
            opensWindow(opener => {
                callApi("account/stripe_customer_portal", "POST", this.props.auth, undefined, {
                    success: response => {
                        opener(response.url);
                    },
                    generic: () => {
                        toastr.error(t("my_account.error_contact"));
                    }
                });
            });
        };
        this.refreshPurchase = (loggedIn) => {
            const token = loggedIn.jwtToken;
            let headers = new Headers();
            headers.set("Authorization", `Bearer ${token}`);
            return fetch(BACKEND_API + "/plans/refresh", {
                method: "POST",
                headers: headers,
            }).then(r => {
                if (r.status == 200) {
                    toastr.success(t("my_account.refresh_success"));
                    reauthFromCurrentLogin();
                    this.refreshAccountDetails();
                }
                else if (r.status == 404) {
                    toastr.error(t("my_account.refresh_error"));
                }
            });
        };
        this.setPassphrase = (loggedIn) => {
            const passphrase = prompt("Enter passphrase", undefined);
            if (!passphrase)
                return;
            const token = loggedIn.jwtToken;
            let headers = new Headers();
            headers.set("Authorization", `Bearer ${token}`);
            callApi("account/set_passphrase", "POST", this.props.auth, { passphrase }, {
                success: response => {
                    toastr.success("Successfully set passphrase.");
                    reauthFromCurrentLogin();
                    this.refreshAccountDetails();
                },
                generic: () => {
                    toastr.error("Could not set passphrase. If you get this error repeatedly, please report this to support@chemix.org");
                }
            });
        };
        this.render = () => (React.createElement(CommonModal, Object.assign({}, this.props, { extraClass: "my-account-modal", title: t("My account"), icon: "fa-square-user", onShow: () => this.refreshAccountDetails() }), this.props.auth.state == "logged_in" ? this.renderLoggedIn(this.props.auth) : this.renderLoggedOut()));
        this.renderLoggedIn = (state) => {
            var _a;
            return (React.createElement(React.Fragment, null,
                React.createElement(AccountRow, Object.assign({}, state, { staySignedIn: this.state.staySignedIn, toggleStayLoggedIn: (v) => this.toggleStayLoggedIn(v) })),
                this.subscriptionRow(state, this.state.accountDetails),
                (((_a = this.state.accountDetails) === null || _a === void 0 ? void 0 : _a.type) === "domain" && this.state.accountDetails.passphraseStatus)
                    ? this.passphraseRow(state, this.state.accountDetails.passphraseStatus)
                    : undefined,
                React.createElement("div", { className: "my-1 text-center" },
                    React.createElement("div", { className: "ui-button", onClick: () => this.signOut(), key: "logoutButton" },
                        React.createElement("i", { className: "fas fa-sign-out-alt mr-2" }),
                        t('Sign out')),
                    React.createElement("button", { className: "ui-button ml-1", onClick: () => this.close(), key: "closeButton" }, t("Close")))));
        };
        this.subscriptionRow = (auth, accountDetails) => (React.createElement(Row, { heading: "Subscription" }, (() => {
            if (!accountDetails)
                return this.individualAccountDetails(auth, undefined);
            switch (accountDetails.type) {
                case "domain": return this.domainAccountDetails(auth, accountDetails);
                case "managed": return this.managedAccountDetails(accountDetails);
                case "individual": return this.individualAccountDetails(auth, accountDetails);
            }
        })()));
        this.passphraseRow = (auth, passphraseStatus) => {
            const buttonText = passphraseStatus === "unset" ? "Set passphrase" : "Change passphrase";
            const explanationText = (() => {
                switch (passphraseStatus) {
                    case "correct": return "Your passphrase is correctly set up.";
                    case "incorrect": return "Your current passphrase is incorrect.";
                    case "unset": return "Your organisation's subscription requires you to have a valid passphrase set up. ";
                }
            })();
            return React.createElement(Row, { heading: "Passphrase" },
                React.createElement("p", null, explanationText),
                React.createElement("button", { className: "ui-button", onClick: () => this.setPassphrase(auth) }, buttonText));
        };
        this.individualAccountDetails = (loggedIn, accountDetails) => (React.createElement(React.Fragment, null,
            accountDetails ?
                this.renderCurrentAccountDetails(accountDetails)
                : this.renderStartAccountDetails(),
            accountDetails && !accountDetails.auto_renew ?
                React.createElement("div", { className: "ui-button mr-1 mb-1", onClick: this.resumeSubscription },
                    React.createElement("i", { className: "" }),
                    t("Resume plan"))
                : undefined, // Show the "Select plan" button only if the user does not have an account.
            !accountDetails ?
                React.createElement(TierContext.Consumer, null, tiers => (React.createElement("div", { className: "ui-button mr-1 mb-1 highlight", onClick: () => tiers.popup("MyAccount"), key: "plan" },
                    React.createElement("i", { className: "" }),
                    t('Upgrade plan'))))
                : /* Otherwise show a "Manage subscription" button that takes users to Stripe portal. */
                    React.createElement("div", { className: "ui-button mr-1 mb-1", onClick: this.openStripeCustomerPortal, key: "manage" },
                        React.createElement("i", { className: "" }),
                        t('Manage')),
            React.createElement("div", { className: "ui-button mr-1", onClick: () => this.refreshPurchase(loggedIn) },
                React.createElement("i", { className: "" }),
                t("Refresh")),
            accountDetails && accountDetails.auto_renew && !this.state.showCancelDialog ?
                React.createElement("div", { className: "ui-button mr-1 mb-1", onClick: () => this.setState({ showCancelDialog: true }) },
                    React.createElement("i", { className: "" }),
                    t("Cancel plan"))
                : undefined,
            this.state.showCancelDialog ?
                React.createElement(CancelPlanConfirmation, { onConfirm: () => { this.cancelSubscription(); this.setState({ showCancelDialog: false }); }, onNoop: () => this.setState({ showCancelDialog: false }) })
                : undefined,
            React.createElement("div", { className: "text-muted my-1" },
                React.createElement(Trans, { i18nKey: "my_account.contact_footer" },
                    "Got a question? ",
                    React.createElement("a", { href: "#", onClick: () => { Bcn.ask(); return false; } }, "Chat to us"),
                    " or email ",
                    React.createElement("a", { href: "mailto:support@chemix.org", target: "_blank" }, "support@chemix.org"),
                    ".")),
            !accountDetails &&
                React.createElement(OrgAccessPassphrase, { loggedIn: loggedIn, auth: this.props.auth, summaryType: "basic", onSuccess: () => {
                        reauthFromCurrentLogin();
                        this.refreshAccountDetails();
                    } })));
        this.domainAccountDetails = (loggedIn, details) => (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                t('my_account.current_plan'),
                ": ",
                React.createElement(SchoolBadge, null),
                React.createElement("b", null, t("School")),
                " ",
                React.createElement("br", null)),
            React.createElement("p", null, t('my_account.school_plan_description', { domain: details.domain })),
            (details.orgAccessPassphraseStatus === "incorrect")
                ? React.createElement(OrgAccessPassphrase, { loggedIn: loggedIn, auth: this.props.auth, summaryType: "incorrect", onSuccess: () => {
                        reauthFromCurrentLogin();
                        this.refreshAccountDetails();
                    } })
                : undefined));
        this.managedAccountDetails = (details) => (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                t('my_account.current_plan'),
                ": ",
                React.createElement(Badge, { tier: details.tier, hideHint: true, extraClass: "fa-fw" }),
                React.createElement("b", null,
                    details.tier.capitalise(),
                    " "),
                " ",
                React.createElement("br", null)),
            React.createElement("p", null, t('my_account.managed_group_plan_description', { group: details.managedBy })),
            details.manageLevel && details.groupId && React.createElement(ManageGroup, { groupId: details.groupId, auth: this.props.auth })));
        /** Renders the account summary if the user does not have a paid subscription. */
        this.renderStartAccountDetails = () => (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                t('my_account.current_plan'),
                ": ",
                React.createElement("b", null, "Start"))));
        this.renderCurrentAccountDetails = (details) => {
            const next_payment_date = format(details.next_payment_date, "d MMM yyyy", { locale: getDateFnsLocale() });
            const payment = `${details.currency} ${details.payment}`;
            return React.createElement("p", null,
                t('my_account.current_plan'),
                ": ",
                React.createElement(Badge, { tier: details.tier, hideHint: true, extraClass: "mr-1" }),
                React.createElement("b", null,
                    details.tier.capitalise(),
                    " "),
                " ",
                React.createElement("br", null),
                details.auto_renew ?
                    details.is_trial ?
                        React.createElement(Nl, null, t("my_account.subscription.trial", { next_payment_date, payment }))
                        :
                            React.createElement(Nl, null, t("my_account.subscription.active", { next_payment_date, payment }))
                    : React.createElement(Nl, null, t("my_account.subscription.ending", { next_payment_date })));
        };
        this.renderLoggedOut = () => (React.createElement("div", null, "You are signed out."));
        this.state = {
            fetchedAccountDetails: false,
            staySignedIn: retrieveToken() != null,
            showCancelDialog: false,
        };
    }
    close() {
        this.props.setIsOpen(false);
    }
    signOut() {
        store.dispatch(logOut());
        this.close();
    }
    toggleStayLoggedIn(staySignedIn) {
        if (this.props.auth.state == "logged_in") {
            if (staySignedIn) {
                // Store token.
                clog("store token to storage");
                storeToken(this.props.auth.jwtToken);
            }
            else {
                // Erase token.
                clog("Clear token");
                clearToken();
            }
            toastr.success(t('my_account.preference_saved'));
            this.setState({
                staySignedIn: staySignedIn
            });
        }
    }
    refreshAccountDetails() {
        callApi("account/details", "GET", this.props.auth, undefined, {
            success: response => {
                // Convert the response to state.
                const accountDetails = response.planDetails;
                this.setState({ fetchedAccountDetails: true });
                this.setState((() => {
                    if (!accountDetails) {
                        return { accountDetails: undefined };
                    }
                    switch (accountDetails.type) {
                        case "individual":
                            return {
                                accountDetails: {
                                    type: accountDetails.type,
                                    tier: accountDetails.tier,
                                    payment: accountDetails.payment,
                                    currency: accountDetails.currency,
                                    interval: accountDetails.interval,
                                    next_payment_date: new Date(accountDetails.next_payment_date),
                                    auto_renew: accountDetails.auto_renew,
                                    is_trial: accountDetails.is_trial,
                                }
                            };
                        case "managed":
                        case "domain":
                            return { accountDetails };
                    }
                })());
            },
        });
    }
}
const AccountRow = (_a) => {
    var { staySignedIn, toggleStayLoggedIn } = _a, state = __rest(_a, ["staySignedIn", "toggleStayLoggedIn"]);
    const { t } = useTranslation();
    return React.createElement(Row, { heading: t('Account') },
        React.createElement("div", { className: "account-summary", key: "summary" },
            React.createElement("div", { className: "avatar" },
                React.createElement("img", { height: "48", src: state.user.avatarUrl }),
                React.createElement("span", { className: "provider_icon fa-stack fa-2x" },
                    React.createElement("i", { className: "fas fa-circle fa-stack-2x" }),
                    React.createElement("i", { className: `${loginProviderIcon(state.provider)} fa-stack-1x fa-inverse` }))),
            React.createElement(CurrentlySignedIn, { provider: state.provider, handle: state.user.handle })),
        React.createElement(StaySignedInCheckbox, { key: "stayLoggedIn", value: staySignedIn, onChange: v => toggleStayLoggedIn(v) }));
};
const CurrentlySignedIn = ({ provider, handle }) => {
    const { t } = useTranslation();
    return React.createElement("span", null, t('login.current_login', { provider: t(loginProviderDisplayName(provider)), handle }));
};
/** A row (or section) containing some settings. */
const Row = (props) => React.createElement(React.Fragment, null,
    React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-12 col-sm-3 text-muted text-sm-right" },
            React.createElement("b", null, props.heading)),
        React.createElement("div", { className: "col-12 col-sm-9 text-left" }, props.children)),
    React.createElement("hr", null));
const CancelPlanConfirmation = (props) => {
    const { t } = useTranslation();
    return React.createElement("div", { className: "mt-2 border border-danger rounded text-left p-2" },
        React.createElement("p", { className: "text-danger" },
            React.createElement("b", null, t("my_account.cancel_are_you_sure"))),
        React.createElement("ul", { className: "fa-ul feature-list mt-1" },
            React.createElement(Item, { icon: "flask" },
                React.createElement(Trans, { i18nKey: "promo.apparatus_count", count: releasedItemsCount },
                    React.createElement("b", null, "1"),
                    " available apparatus")),
            React.createElement(ExportHighQuality, null),
            React.createElement(Item, { icon: "infinity fas" }, t("promo.unlimited_image_exports")),
            React.createElement(Item, { icon: "cloud" },
                React.createElement(Trans, { i18nKey: "promo.store_n_cloud", count: BOOST_TOTAL_DIAGRAMS },
                    "Store ",
                    React.createElement("b", null, "3"),
                    " diagrams in Cloud")),
            React.createElement(BoostFeatureList, { skipFirstLine: true })),
        React.createElement("button", { className: "ui-button mr-1", onClick: props.onNoop }, t("my_account.cancel_no")),
        React.createElement("button", { className: "ui-button mr-1 danger", onClick: props.onConfirm }, t("my_account.cancel_confirm")));
};
const OrgAccessPassphrase = ({ loggedIn, auth, onSuccess, summaryType }) => {
    const [show, setShow] = useState(false);
    const [name, setName] = useState("");
    const [passphrase, setPassphrase] = useState("");
    function onClick() {
        let headers = new Headers();
        headers.set("Authorization", `Bearer ${loggedIn.jwtToken}`);
        let args = { name, passphrase };
        callApi("account/set_access_passphrase", "POST", auth, args, {
            success: response => {
                toastr.success(t('my_account.org_access_passphrase.update_success'));
                onSuccess();
            },
            special: (error) => {
                if (error.error_type !== "set_access_passphrase_error") {
                    return false;
                }
                toastr.error(t(`my_account.org_access_passphrase.error.${error.additional_detail}`));
                return true;
            },
            generic: () => {
                toastr.error("Could not set passphrase. If you get this error repeatedly, please report this to support@chemix.org");
            }
        });
    }
    if (!show) {
        if (summaryType == "basic") {
            return React.createElement(ClickToShowOrgAccessPassphrase, { show: () => setShow(true) });
        }
        else if (summaryType == "incorrect") {
            return React.createElement(IncorrectOrgAccessPassphrase, { show: () => setShow(true) });
        }
    }
    return React.createElement("div", null,
        React.createElement("b", null, t('my_account.org_access_passphrase.name')),
        React.createElement("div", null, t('my_account.org_access_passphrase.org_name')),
        React.createElement("div", null,
            React.createElement("input", { name: "name", className: "ui-input", value: name, onChange: (e) => setName(e.target.value) })),
        React.createElement("div", { className: "mt-2" }, t('my_account.org_access_passphrase.passphrase')),
        React.createElement("div", null,
            React.createElement("input", { name: "passphrase", className: "ui-input", value: passphrase, onChange: (e) => setPassphrase(e.target.value) })),
        React.createElement("div", { className: "mt-2" },
            React.createElement("button", { className: "ui-button", onClick: onClick }, t('my_account.org_access_passphrase.update_button'))));
};
const ClickToShowOrgAccessPassphrase = ({ show }) => {
    return React.createElement("div", { className: "text-muted my-1" },
        React.createElement(Trans, { i18nKey: "my_account.org_access_passphrase.setup_prompt" },
            "If you have an Organisation Access Code, ",
            React.createElement("a", { href: "#", onClick: () => { show(); return false; } }, "click here")));
};
const IncorrectOrgAccessPassphrase = ({ show }) => {
    return React.createElement("div", { className: "text-danger my-1" },
        React.createElement(Trans, { i18nKey: "my_account.org_access_passphrase.incorrect_prompt" },
            "Your Organisation Access Code is incorrect. ",
            React.createElement("a", { href: "#", onClick: () => { show(); return false; } }, "Update")));
};
